import {getParameterByName} from '../utils/tools';
let mode = null;
const getMode = () => {
    if (mode !== null) {
        return mode;
    }
    let _mode = 'STUDENT';
    if (getParameterByName('mode') === 'teacher') {
        _mode = 'TEACHER';
    } else if (getParameterByName('mode') === 'assistant') {
        _mode = 'ASSISTANT';
    }
    mode = _mode;
    return mode;
};
const isNoMenu = function () {
    if (getParameterByName('nomenu') === '1') {
        return true
    }
    return false
}
const isStudentMode = function (){
    if (getMode() === 'STUDENT') {
        return true;
    }
    return false;
};
const isTeacherMode = function (){
    if (getMode() === 'TEACHER') {
        return true;
    }
    return false;
};
const isAssistantMode = function () {
    if (getMode() === 'ASSISTANT') {
        return true;
    }
    return false;
};
const isTutor = function () {
    if (getParameterByName('isTutor') === '1') {
        return true;
    }
    return false;
};
const isTestingMode = function (){
    if (window.location.hostname.includes('testing') ||
    window.location.hostname.substr(0, 1).match(/\d/)
    ) {
        return true;
    }
    return false;
};
const isCreateMode = function (){
    const courseId = getParameterByName('courseId');
    const unitId = getParameterByName('unitId');
    const lessonId = getParameterByName('lessonId');
    const homeworkId = getParameterByName('homeworkId');
    if ((courseId !== '' && unitId !== '' && lessonId !== '') || homeworkId !== '') {
        return false;
    }
    return true;
};

const isAutoJudgementConfig = ()=> new URLSearchParams(location.search).get('autoJudgementConfig') === '1'
const isFlyoutVisbile = ()=> {
    const params = new URLSearchParams(location.search);
    if (params.get('flyout') === '0') {
        return false;
    }
    return true;
}; 

//页面缩放，为了让课导能看到更多代码
const getZoomValue = () => {
    const params = new URLSearchParams(location.search);
    return params.get('zoom');
}

export {
    isStudentMode,
    isTeacherMode,
    isAssistantMode,
    isTestingMode,
    isCreateMode,
    isTutor,
    isNoMenu,
    getMode,
    isAutoJudgementConfig,
    isFlyoutVisbile,
    getZoomValue
};
